import React from 'react';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { aiCards, images } from '../mock';

const AISection = ({ onDownload }) => {
  return (
    <section className="bg-[#0b1510] py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-end mb-14">
          <div>
            <p className="text-sm font-semibold text-[#3ddc9a] mb-4">FLIX AI</p>
            <h2 className="font-display text-4xl sm:text-5xl font-700 text-white leading-tight">
              The potential in your business? <span className="text-[#3ddc9a]">FLIX finds it.</span>
            </h2>
          </div>
          <p className="text-white/55 text-lg leading-relaxed">
            You built the business. FLIX shows you how far it can go — spotting patterns, surfacing opportunities and flagging problems before they cost you money. Not a tool you check, a partner that checks on you.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {aiCards.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Circle;
            return (
              <div key={i} className="rounded-3xl bg-white/[0.04] border border-white/10 p-7 hover:bg-white/[0.07] transition-colors">
                <div className="w-12 h-12 rounded-2xl bg-[#3ddc9a]/15 flex items-center justify-center mb-6">
                  <Icon size={22} className="text-[#3ddc9a]" />
                </div>
                <h3 className="font-display text-lg font-600 text-white mb-2">{c.title}</h3>
                <p className="text-sm text-white/55 leading-relaxed">{c.text}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-14 rounded-[2rem] overflow-hidden grid lg:grid-cols-2 bg-white/[0.03] border border-white/10">
          <div className="p-10 sm:p-12 flex flex-col justify-center">
            <h3 className="font-display text-3xl font-700 text-white leading-tight">Gets you paid. Then gets you growing.</h3>
            <p className="text-white/55 mt-5 leading-relaxed">
              Sales insights, a payment-ready storefront, and marketing on demand. FLIX doesn’t wait for you to ask — it turns your sales history into a plan for what’s next.
            </p>
            <button onClick={onDownload} className="mt-8 inline-flex items-center gap-2 bg-[#0e9f6e] text-white rounded-xl px-7 py-4 text-sm font-semibold hover:bg-[#0c8a60] hover:scale-[1.02] active:scale-95 transition-all w-fit">
              Explore FLIX AI <ArrowRight size={16} />
            </button>
          </div>
          <div className="aspect-[4/3] lg:aspect-auto overflow-hidden">
            <img src={images.freelancer} alt="FLIX AI insights" loading="lazy" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AISection;
